import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Banner } from '@calendly/ui/components/banner'
import { Link } from '@calendly/ui/components/link'

import { ContactLink } from './contact_link'
import BillingClickCapture from '../../components/billing/click_capture'


const UpgradeLink = ({ children }) => (
  <BillingClickCapture featureName="managed_events" skipPreface>
    <Link variant="subtle" as="button">
      {children}
    </Link>
  </BillingClickCapture>
)

export const NotAvailableBanner = () => (
  <Banner spacingBottom={16} spacingTop={16} type="warning">
    {HtmlParser(I18n.t('publisher.organization.managed_event_types.intro_state.not_available_banner'), { UpgradeLink, ContactLink })}
  </Banner>
)
